







export default {
  name: 'game-cards'

  data: ->
    cards: require '@/assets/images/lucre-games-geotap-game-casual-relaxing-low=poly-design-game-cards.png'
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GameCards.vue